import { useMemo } from 'react';
import {
  calculateSharedAggregates,
  calculateSharedMetrics,
  calculateSharedTopInfluencers,
} from '../services/sharedAnalyticsCalculations.service';
import { calculateTopPosts } from '../services/analyticsCalculations.service';
import type { PublicDeliverableAggregate, SharedMetricsData } from '../types/sharedAnalytics.types';
import type { TopInfluencer } from '../types/analytics.types';
import type { TopPost } from '@/hooks/useTopPerformingPosts';

export interface UseSharedAnalyticsCalculationsProps {
  aggregates: PublicDeliverableAggregate[];
  summaryData?: {
    cpv?: number | null;
    cpe?: number | null;
  } | null;
  posts: TopPost[];
  showAllInfluencers: boolean;
  showAllPosts: boolean;
}

export function useSharedAnalyticsCalculations({
  aggregates,
  summaryData,
  posts,
  showAllInfluencers,
  showAllPosts,
}: UseSharedAnalyticsCalculationsProps) {
  const rawAggregates = useMemo(
    () => calculateSharedAggregates(aggregates),
    [aggregates]
  );

  const metrics: SharedMetricsData = useMemo(
    () => calculateSharedMetrics(rawAggregates, summaryData),
    [rawAggregates, summaryData]
  );

  const topInfluencers: TopInfluencer[] = useMemo(
    () => calculateSharedTopInfluencers(aggregates, showAllInfluencers),
    [aggregates, showAllInfluencers]
  );

  const topPosts: TopPost[] = useMemo(
    () => calculateTopPosts(posts, showAllPosts),
    [posts, showAllPosts]
  );

  return {
    metrics,
    topInfluencers,
    topPosts,
  };
}
